import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "18",
  height: "18",
  viewBox: "0 0 18 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M16.4693 2.24003L15.7693 1.53003L8.9993 8.29003L2.2393 1.53003L1.5293 2.24003L8.2893 9.00003L1.5293 15.77L2.2393 16.47L8.9993 9.71003L15.7693 16.47L16.4693 15.77L9.7093 9.00003L16.4693 2.24003Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }